// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3ZxcM","list":"PatternAutocomplete_list__2mUgs"};